import { createContext, useState, useEffect, useContext } from "react";
import GetConfigWhiteLabel from "../services/GetWhiteLabel";

interface WhiteLabelContextData {
  whitelabel: object | null;
}

export const WhiteLabelContext = createContext<WhiteLabelContextData>(
  {} as WhiteLabelContextData
);

export const WhiteLabelProvider = ({ children }: any) => {
  const [whitelabel, setWhiteLabel] = useState({
    chaveMovidesk: "",
    colorDefault: "",
    contact: "",
    devName: "",
    devUrl: "",
    heightLogo: "",
    identify: "",
    licences: "",
    linkFavicon: "",
    logo: "",
    name: "",
    site: "",
    title: "",
    urlApi: "",
    apiCode: "",
    titleAba: "",
    imgAba: "",
    titleParceria: "",
    descriptionParceria: "",
    btnHomeTitle: "",
    btnHomeLink: "",
    linkSejaConnect: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    ambiente: "",
    phone: "",
    isWhatsapp: "",
    mostraPrecoCheio: "",
    analyticsID: "",
    adsID: "",
    moduleID: 0,
  });

  useEffect(() => {
    try {
      const response = GetConfigWhiteLabel();
      response.then((res) =>
        setWhiteLabel({
          chaveMovidesk: res?.chaveMovidesk,
          colorDefault: res?.colorDefault,
          contact: res?.contact,
          devName: res?.devName,
          devUrl: res?.devUrl,
          heightLogo: res?.heightLogo,
          identify: res?.identify,
          licences: res?.licences,
          linkFavicon: res?.linkFavicon,
          logo: res?.logo,
          name: res?.name,
          site: res?.site,
          title: res?.title,
          urlApi: res?.urlApi,
          apiCode: res?.apiCode,
          titleAba: res?.titleAba,
          imgAba: res?.imgAba,
          titleParceria: res?.titleParceria,
          descriptionParceria: res?.descriptionParceria,
          btnHomeTitle: res?.btnHomeTitle,
          btnHomeLink: res?.btnHomeLink,
          linkSejaConnect: res?.linkSejaConnect,
          facebook: res?.facebook,
          linkedin: res?.linkedin,
          instagram: res?.instagram,
          ambiente: res?.ambiente,
          phone: res?.phone,
          isWhatsapp: res?.isWhatsapp,
          mostraPrecoCheio: res?.mostraPrecoCheio,
          analyticsID: res?.analyticsID,
          adsID: res?.adsID,
          moduleID: res?.moduleID,
        })
      );
      /* 
            Página que seta os titulo usa o hook forwardRef, com isso não podendo buscar os dados via context    
            */
      sessionStorage.setItem("@App:title", whitelabel?.title);
      sessionStorage.setItem("@App:linkFavicon", whitelabel?.linkFavicon);
      sessionStorage.setItem("@App:urlApi", whitelabel?.urlApi);
      sessionStorage.setItem("@App:identify", whitelabel?.identify);
      sessionStorage.setItem("@App:titleAba", whitelabel?.titleAba);
      sessionStorage.setItem("@App:logo", whitelabel?.logo);
      sessionStorage.setItem("@App:titleParceria", whitelabel?.titleParceria);
      sessionStorage.setItem(
        "@App:descriptionParceria",
        whitelabel?.descriptionParceria
      );
      sessionStorage.setItem("@App:apiCode", whitelabel?.apiCode);
    } catch (err) {
      console.log(err);
    }
  }, [
    whitelabel?.title,
    whitelabel?.linkFavicon,
    whitelabel?.urlApi,
    whitelabel?.identify,
    whitelabel?.titleAba,
    whitelabel?.logo,
    whitelabel?.titleParceria,
    whitelabel?.descriptionParceria,
    whitelabel?.apiCode,
    whitelabel?.ambiente,
  ]);

  return (
    <WhiteLabelContext.Provider value={{ whitelabel }}>
      {children}
    </WhiteLabelContext.Provider>
  );
};

export function useWhiteLabel() {
  const context = useContext(WhiteLabelContext);
  return context;
}
